<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="gerarAtendDeReqModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Gerar {{ para_orcamento ? 'Orçamento' : 'Atendimento' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao && lista">
                        <div class="alert alert-info">
                            {{ nome_paciente }}
                        </div>

                        <div class="form-row mb-3" v-if="!para_orcamento">
                            <div class="col col-12 col-md-2">
                                <az-input
                                    icon="fa-regular fa-calendar"
                                    type="date"
                                    v-model="data_atendimento"/>
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    type="time"
                                    v-model="hora_atendimento"/>
                            </div>
                            <div class="col col-12 col-md-8">
                                <az-input 
                                    placeholder="Sinalizador (opcional)..."
                                    type="select" 
                                    optionsMode="aql"
                                    service="sinalizadores.index"
                                    :optionsParm="{ ativos: true }"
                                    v-model="sinalizador">
                                    <template v-slot:button-pre> 
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">
                                                <i  :class="sinalizador 
                                                        ? ( sinalizador.st_icon ? sinalizador.st_icon : 'fas fa-flag' ) + ' text-' + sinalizador.st_cor 
                                                        : 'fas fa-question'" 
                                                    aria-hidden="true"></i>
                                            </span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <!-- Fase 1 - Confirmação dos Procedimentos -->
                        <div class="row" v-if="fase == 1">
                            <div class="col col-12">
                                <ul class="list-group small">
                                    <template v-for="(lista_items, grupo, igx) in lista">
                                        <li class="list-group-item list-group-item-secondary d-flex justify-content-between py-1" :key="igx" v-if="grupo">
                                            <div>
                                                <a href="#" @click.prevent="selecionar_grupo(lista_items)" class="card-link">
                                                    <i class="fa fa-square mr-2" aria-hidden="true"></i>
                                                    {{ grupo }}
                                                </a>
                                            </div>
                                            <div>
                                                <span class="badge" :class="( selecionados.length == lista_items.length ) ? 'badge-success' : ( selecionados.length ? 'badge-warning' : 'badge-secondary' )">
                                                    {{ lista_items.filter(it => it.selecionado).length }}/{{ lista_items.length }}
                                                </span>
                                            </div>
                                        </li>
                                        
                                        <li class="list-group-item d-flex justify-content-between py-2" v-for="(item, idx) in lista_items" :key="igx + '.' + idx">
                                            <div v-if="item">
                                                <input type="checkbox" class="mr-3" v-model="item.selecionado" />
                                                <span>{{ item.search }}</span>
                                                <span class="badge badge-secondary ml-2" v-if="item.in_quantidade > 1" title="Quantidade">x{{ item.in_quantidade }}</span>
                                                <span v-if="item.block_cobranca" class="badge badge-warning ml-2">
                                                    <i class="fa-solid fa-triangle-exclamation mr-1"></i> Procedimento não vinculado a item cobrança
                                                </span>
                                                <div class="text-muted" style="white-space: pre-wrap;">{{ item.st_observacoes }}</div>
                                            </div>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </div>

                        <!-- Fase 2 - Confirmação do Profissional -->
                        <template v-else-if="fase == 2">
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <ul class="list-group">
                                        <li class="list-group-item" v-for="(proc, ipx) in selecionados" :key="ipx">
                                            {{ proc.search }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col col-12 col-md-6">
                                    <h5>Selecione o Profissional</h5>

                                    <ul class="list-group">
                                        <div class="list-group">
                                            <button type="button" class="list-group-item list-group-item-action" v-if="para_orcamento" @click="selecionar_medico(null)" :disabled="$store.state.loading">
                                                NÃO DEFINIDO
                                            </button>

                                            <button type="button" class="list-group-item list-group-item-action" v-for="(item, idx) in lista_medicos" :key="idx" @click="selecionar_medico(item.medico_unidade.medico)" :disabled="$store.state.loading">
                                                <div v-if="item && item.medico_unidade && item.medico_unidade.medico">
                                                    {{ item.medico_unidade.medico.st_nome_exibicao }}
                                                </div>    
                                            </button>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </template>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="confirmar_procedimentos()" v-if="fase == 1">Confirmar Procedimentos</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue'; 

export default {
    data() {
        return {
            edicao: null,
            fase: 1, 
            lista: null, 
            id_unidade_operacao: "", 
            data_atendimento: "", 
            hora_atendimento: "", 
            sinalizador: "", 
            para_orcamento: false, 
        }
    },

    components: { 
        AzInput,
        AzSubmit,
    },

    computed: { 
        nome_paciente: function () { 
            return _.get(this.edicao, 'anamnese.atendimento_procedimento.atendimento.paciente.st_nome');
        },

        selecionados: function () { 
            return _.orderBy(
                _.flatMap(this.lista, items => items).filter(item => item.selecionado),
                'search'
            );
        },
    },

    methods: { 
        selecionar_medico (medico) { 

            if ( this.para_orcamento ) { 

                let req = _.cloneDeep(this.edicao);
                req.items = this.selecionados;
                req.medico_orc = medico;  
                req.from_crm = true; 

                console.log('req orcamento', req);

                $('.modal').modal('hide');

                this.$router.push(
                    {
                        name: 'crmorcamento', 
                        params: { 
                            origem: req
                        } 
                    }
                );

                return; 

            }

            this.$util.atualizar(this, { 
                service: 'orcamentos',
                func: 'converter',
                dados: { 
                    paciente: this.edicao.anamnese.atendimento_procedimento.atendimento.paciente,
                    plano: this.plano, 
                    id_unidade_operacao: this.id_unidade_operacao, 
                    id_recepcao: this.id_recepcao,
                    id_requisicao: this.edicao.id_requisicao,
                    atender: true, 
                    data: this.data_atendimento,
                    hora: this.hora_atendimento,
                    id_sinalizador_atendimento: this.sinalizador ? this.sinalizador.id_sinalizador_atendimento : null,
                    js_procedimentos: this.selecionados.map(item => { 
                        return {
                            procedimento: item, 
                            selecionado: true, 
                            medico: medico, 
                            in_quantidade: 1, 
                        };
                    }),
                    force_componentes: true, 
                },
                callback: res => { 
                    $('#gerarAtendDeReqModal').modal('hide');

                    console.log('res', res);
                }
            })
        },

        selecionar_grupo (lista) { 
            let todos_selecionados = lista.every(item => item.selecionado); //  || item.block_cobranca);

            lista.forEach(item => { 
                //if ( item.block_cobranca ) { 
                    //return;
                //}

                item.selecionado = !todos_selecionados;
            });
        },

        confirmar_procedimentos () { 

            if ( !this.selecionados.length ) { 
                this.$toast.add({ 
                    severity: 'warn', 
                    summary: 'Atenção', 
                    detail: 'Selecione ao menos um procedimento para continuar.', 
                    life: 3000 
                });
                return;
            }

            this.$util.load(this, { 
                service: 'marcacoes',
                func: 'lista_alterar_profissional',
                parms: { 
                    orcamento: true, 
                    id_procedimento: _.get(_.first(this.selecionados), 'id_procedimento'), 
                    id_operadora: this.plano.id_operadora, 
                    is_lab: _.get(_.first(this.selecionados), 'id_especialidade') == 2 ? true : false,
                    id_unidade_operacao: this.id_unidade_operacao,
                },
                loadTo: res => { 
                    this.lista_medicos = res.filter(item => item && item.medico_unidade && item.medico_unidade.medico);

                    if ( this.lista_medicos && this.lista_medicos.length == 1 && _.get(this.lista_medicos, '0.medico_unidade.medico') ) { 
                        this.selecionar_medico(this.lista_medicos[0].medico_unidade.medico);
                        return;
                    }
                    
                    this.fase = 2; 
                }
            });

        },

        abrir(edicao, plano = null, para_orcamento = false) {
            $('.modal').modal('hide');

            this.fase = 1; 

            this.edicao = null;
            this.lista = null;
            this.para_orcamento = para_orcamento ? true : false;
            this.id_unidade_operacao = this.$util.getCookie('id_unidade_operacao');
            this.id_recepcao = this.$util.getCookie('id_recepcao');

            this.$nextTick(() => {
                
                this.edicao = _.cloneDeep(edicao); 
                this.plano = plano ? plano : this.edicao.anamnese.atendimento_procedimento.atendimento.plano;
    
                this.lista = _.groupBy(
                    this.edicao.items.flatMap(item => { 

                        if ( item.item && ( item.item.unidade === null || ( item.item.unidade && !item.item.unidade.fl_ativo ) ) ) { 
                            return [
                                {
                                    id_requisicao_procedimento: item.id_requisicao_procedimento,
                                    id_procedimento: item.id_procedimento,
                                    id_especialidade: _.get(item, 'item.id_especialidade'),
                                    in_quantidade: item.in_quantidade,
                                    st_observacoes: item.st_observacoes,
                                    search: _.get(item, 'item.search'),
                                    grupo: _.get(item, 'item.grupo.search'),
                                    selecionado: false,
                                    item: item.item,
                                    block_cobranca: true, 
                                }
                            ];
                        }

                        return [
                            {
                                id_requisicao_procedimento: item.id_requisicao_procedimento,
                                id_procedimento: item.id_procedimento,
                                id_especialidade: _.get(item, 'item.id_especialidade'),
                                in_quantidade: item.in_quantidade,
                                st_observacoes: item.st_observacoes,
                                search: _.get(item, 'item.search'),
                                grupo: _.get(item, 'item.grupo.search'),
                                selecionado: false,
                                item: item.item,
                            }
                        ];
                    }),
                    (item) => item.grupo ? item.grupo : '-'
                );
    
                $('#gerarAtendDeReqModal').modal('show');

            });

        },
    }
}
</script>
